"use client";

import { cn, Icon, Select, SelectItem, Typography } from "@kyan/ui";

import { parseMaturity } from "#/utils/maturity";

import { PositionIndicator } from "./components/PositionIndicator/PositionIndicator";
import { useMaturitySelectorController } from "./MaturitySelector.controller";

export const MaturitySelector: React.FC = () => {
  const { maturity, maturities, visibleItems, wrapperRef, setMaturity } =
    useMaturitySelectorController();

  return (
    <div ref={wrapperRef} className="flex w-full items-center gap-1.5">
      <ul className="bg-background border-divider flex rounded-xs border">
        {visibleItems.map((item, index) => (
          <li className="group" key={item.maturity}>
            <button
              tabIndex={index + 1}
              className={cn(
                "border-divider hover:bg-buttonHover h-8 w-35 cursor-pointer border-r group-last:border-none",
                {
                  "bg-buttonHover": maturity === item.maturity,
                },
              )}
              onClick={() => {
                setMaturity(item.maturity);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setMaturity(item.maturity);
                }
              }}
            >
              <div className="relative flex items-center justify-center">
                <Typography
                  size={12}
                  className={cn("transition-colors", {
                    "text-textPrimary": maturity === item.maturity,
                  })}
                >
                  {parseMaturity(item.maturity, true)}
                </Typography>
                <div className="absolute right-2 flex items-center gap-px">
                  {item.indicators.long && <PositionIndicator variant="long" />}
                  {item.indicators.short && (
                    <PositionIndicator variant="short" />
                  )}
                </div>
              </div>
            </button>
          </li>
        ))}
      </ul>

      <Select
        align="end"
        sideOffset={6}
        value={maturity}
        contentClassName="w-[86px]"
        triggerClassName="h-8 flex items-center group"
        triggerElement={<Icon name="menu" hoverEffect="square" />}
        onValueChange={setMaturity}
      >
        {maturities.map((item) => (
          <SelectItem
            key={item.maturity}
            value={item.maturity}
            className="data-[state=checked]:text-textPrimary h-8 text-xs break-keep"
          >
            {parseMaturity(item.maturity)}
          </SelectItem>
        ))}
      </Select>
    </div>
  );
};
